import React from "react";
import {
  ExclamationTriangleIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";

export interface AlertProps {
  variant?: "info" | "success" | "warning" | "error";
  title?: string;
  description?: string;
  className?: string;
}

const variantStyles = {
  info: {
    container: "bg-tiber-50 border-tiber-200 text-tiber-900",
    icon: "text-tiber-600",
    Icon: InformationCircleIcon,
  },
  success: {
    container: "bg-atlantis-50 border-atlantis-200 text-atlantis-900",
    icon: "text-atlantis-600",
    Icon: CheckCircleIcon,
  },
  warning: {
    container: "bg-amber-50 border-amber-200 text-amber-900",
    icon: "text-amber-600",
    Icon: ExclamationTriangleIcon,
  },
  error: {
    container: "bg-red-50 border-red-200 text-red-900",
    icon: "text-red-600",
    Icon: XCircleIcon,
  },
};

export const Alert: React.FC<AlertProps> = ({
  variant = "info",
  title,
  description,
  className = "",
}) => {
  const styles = variantStyles[variant];
  const Icon = styles.Icon;

  return (
    <div
      className={`flex items-start gap-3 p-4 rounded-lg border ${styles.container} ${className}`}
    >
      <Icon className={`h-5 w-5 shrink-0 ${styles.icon}`} />
      <div className="flex-1">
        {title && <h4 className="font-semibold mb-1">{title}</h4>}
        {description && <p className="text-sm">{description}</p>}
      </div>
    </div>
  );
};
